import Space from 'components/generic/Space.component';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

import CN from './TooltipContentReceptionist.module.scss';

const TooltipContentReceptionist = () => {
  const { t } = useTranslation();

  return (
    <div data-bem="TooltipContentReceptionist" className={CN.component}>
      {S.restricted}
      <Space>{t('composite.tooltipContReceptionist.message')}</Space>
      {S.restricted}
    </div>
  );
};

const TooltipContentReceptionistHoc = TooltipContentReceptionist;

export default TooltipContentReceptionistHoc;
